import React, { useContext, useEffect, useRef, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import {
  FEED_INSTAGRAM,
  STORIES,
  CANVAS_WRAPPER_PRINT_TARGET_CLASSNAME,
  CANVAS_VIWER_TARGET_CLASSNAME,
  PANFLETO,
  MAX_PRODUCTS_FEED_FORMAT,
  MAX_PRODUCTS_STORIES_FORMAT,
  MAX_PRODUCTS,
  CANVAS_TARGET_CLASSNAME,
  CARTAZ_PEQUENO,
  CARTAZ_MEDIO,
  CARTAZ_GRANDE,
  FEED_INSTAGRAM_PORTRAIT,
  CESTA_BASICA_KIT,
} from "./EncarteConstants";

import Loading from "../../sharable/Loading";

import FeedCanvas from "./Canvas/FeedCanvas";
import StoriesCanvas from "./Canvas/StoriesCanvas";
import PanfletoCanvas from "./Canvas/PanfletoCanvas";
import { CanvasWrapper } from "./Canvas/CanvasGeneralStyles";
import WorkspaceContext from "../WorkspaceContext";
import CartazCanvasGrid from "./Canvas/Cartaz/CartazCanvasGrid";
import { isCartazFormat } from "../../../services/Utils";
import CestaBasicaKitCanvasViewer from "./CestaBasicaKitCanvasViewer/CestaBasicaKitCanvasViewer";
const Container = styled.div`
  border-top: 1px solid #d9d9d9;
  position: relative !important;
  padding: 2rem 4.2rem;
  display: flex;
  flex-direction: column;
  height: min-content;
  //overflow: hidden;
`;

const TimeOutAnimation = keyframes`
  to {
    width: 0%;
  }
`;

const PopUpTimeOut = styled.div`
  width: 100%;
  height: 5px;
  background-color: #d97706;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  animation: ${TimeOutAnimation} 15s linear;
`;

const FormatSelector = styled.select`
  background-color: transparent;
  border: none;
  font-size: 1.4rem;
  text-transform: capitalize;
  cursor: pointer;
  &:focus-visible {
    outline-width: 0;
  }

  option {
    cursor: pointer;
  }
`;

const PopUp = styled.div`
  position: fixed;
  top: 10rem;
  right: 4.2rem;
  width: 25rem;
  border-radius: 5px;
  background-color: #171717;
  color: #fff;
  line-height: 1.3;
  font-size: 1.2rem;
  z-index: 10;
  box-shadow: 0px 10px 15px rgba(1, 1, 1, 0.2);

  button {
    all: unset;
    margin-top: 1rem;
    cursor: pointer;
    padding: 0.6rem 1.2rem;
    border: #d9d9d9 1px solid;
    align-self: end;
    border-radius: 5px;
    transition: all 300ms ease-in-out;
    text-transform: capitalize;
    &:hover {
      border-color: transparent;
      color: #d97706;
    }
  }

  .txt-button-wrapper {
    padding: 1.2rem;
  }
`;

export default function SocialMediaCanvasViewer() {
  const {
    model,
    maxProducts,
    userBrand,
    products,
    styles,
    onStylesChange,
    canvasScale,
    grid,
    isEncarteUpdating,
  } = useContext(WorkspaceContext);
  const [showPopUp, setShowPopUp] = useState(false);
  const watchMaxProducts = useEffect(() => {
    const format = styles.format;
    if (
      format === FEED_INSTAGRAM &&
      products.length >= MAX_PRODUCTS_FEED_FORMAT
    ) {
      setShowPopUp(true);
    }
    if (format === STORIES && products.length >= MAX_PRODUCTS_STORIES_FORMAT) {
      setShowPopUp(true);
    }
    if (format === PANFLETO && products.length >= maxProducts) {
      setShowPopUp(true);
    }
    const timer = setTimeout(() => {
      setShowPopUp(false);
    }, 15000);
    return () => clearTimeout(timer);
  }, [products.length, styles.format]);

  return (
    <Container className={`flex align ${CANVAS_VIWER_TARGET_CLASSNAME}`}>
      {isEncarteUpdating ? (
        <Loading txt={"Atualizando encarte..."} />
      ) : styles && userBrand && model ? (
        <>
          {showPopUp ? (
            <PopUp className="flex direction-column">
              <div className="txt-button-wrapper flex direction-column">
                <p>
                  A quantidade máxima de produtos para o formato "
                  {styles.format}" é de{" "}
                  {styles.format === FEED_INSTAGRAM ||
                  styles.format === FEED_INSTAGRAM_PORTRAIT
                    ? MAX_PRODUCTS_FEED_FORMAT
                    : styles.format === STORIES
                      ? MAX_PRODUCTS_STORIES_FORMAT
                      : MAX_PRODUCTS}{" "}
                  produtos, passar disso irá comprometer a qualidade do encarte.
                  Crie outro encarte para continuar adicionando.
                </p>
                <button onClick={() => setShowPopUp(false)}>entendi</button>
              </div>
              <PopUpTimeOut />
            </PopUp>
          ) : (
            ""
          )}
          <FormatSelector
            onChange={(e) => {
              onStylesChange("format", e.target.value);
            }}
            defaultValue={styles.format}
          >
            <optgroup label="Mídia social">
              <option value={FEED_INSTAGRAM}>{FEED_INSTAGRAM}</option>
              <option value={FEED_INSTAGRAM_PORTRAIT}>
                {FEED_INSTAGRAM_PORTRAIT}
              </option>
              <option value={STORIES}>{STORIES}</option>
              <option value={PANFLETO}>{PANFLETO}</option>
            </optgroup>
            {
              <optgroup label="Cartaz Impressão">
                <option value={CARTAZ_PEQUENO}>{CARTAZ_PEQUENO}</option>
                <option value={CARTAZ_MEDIO}>{CARTAZ_MEDIO}</option>
                <option value={CARTAZ_GRANDE}>{CARTAZ_GRANDE}</option>
              </optgroup>
            }
            <optgroup label="Impressão ou Mídia Social">
              <option value={CESTA_BASICA_KIT}>{CESTA_BASICA_KIT}</option>
            </optgroup>
          </FormatSelector>

          <CanvasWrapper className={CANVAS_WRAPPER_PRINT_TARGET_CLASSNAME}>
            {styles.format === FEED_INSTAGRAM ||
            styles.format === FEED_INSTAGRAM_PORTRAIT ? (
              <FeedCanvas
                isTargetCanvas={true}
                grid={grid}
                products={products}
                canvasScale={canvasScale}
                isProductClickable={true}
              />
            ) : styles.format === STORIES ? (
              <StoriesCanvas
                isTargetCanvas={true}
                grid={grid}
                products={products}
                canvasScale={canvasScale}
                isProductClickable={true}
              />
            ) : styles.format === PANFLETO ? (
              <PanfletoCanvas
                grid={grid}
                products={products}
                canvasScale={canvasScale}
                isProductClickable={true}
              />
            ) : isCartazFormat(styles.format) ? (
              // Mostra CartazCanvasGrid para qualquer um dos formatos de prateleira
              <div className={CANVAS_TARGET_CLASSNAME}>
                <CartazCanvasGrid
                  products={products}
                  canvasScale={canvasScale}
                  model={model}
                  styles={styles}
                />
              </div>
            ) : styles.format === CESTA_BASICA_KIT ? (
              <CestaBasicaKitCanvasViewer
                grid={grid}
                products={products}
                canvasScale={canvasScale}
                isProductClickable={true}
              />
            ) : (
              ""
            )}
          </CanvasWrapper>
        </>
      ) : (
        <Loading />
      )}
    </Container>
  );
}

export function copy(src) {
  var dst = new ArrayBuffer(src.byteLength);
  new Uint8Array(dst).set(new Uint8Array(src));
  return dst;
}
